import { formatDate, formatMoney } from './format'
export const moneyOrUnknown = (value: number | null | undefined, currency: string) => value == null ? 'Não informado' : formatMoney(value, currency)
export const financeDate = (value?: string | null) => `${formatDate(value, 'America/Sao_Paulo')}${value ? ' (America/Sao_Paulo)' : ''}`
